import React, { useEffect, useState } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Table, Tag, Space } from 'antd';
import { Select } from 'antd';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import * as XLSX from 'xlsx';
import { useDispatch, useSelector } from "react-redux";
import { getSelectedStoreList, getWareHouseList ,isEdit,addWareHouse,showWareHouseView} from './actions/wareHouseService';
import Cookie from 'js-cookie';
import EditWareHouse from './EditWareHouse';
import AddWareHouse from './AddWareHouse';
import WareHouseView from './WareHouseView';
import { useNavigate } from 'react-router-dom';
import LZString from 'lz-string';
const { Option } = Select;

const WareHouses = () => {
  const [searchedItem, setSearchedItem] = useState({
    wareHouseName:[],
  });
  const storeList = useSelector(state => state?.wareHouse?.WareHouseDetails?.Stores)
  const  AllowWareHouse = useSelector(state => state?.wareHouse?.WareHouseDetails?.AllowWareHouse[0])
  console.log(AllowWareHouse,'AllowWareHouse')
  const status = useSelector(state => state?.wareHouse)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [tableData, setTableData] = useState([])
  const config = JSON.parse(Config);
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData) 
    let userID = user['userId'];  
    const  title = 'Warehouses';
    const  apiInterface = config['api1'];
    
    const TableColumns = [
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size="middle">
              <div className="table-icons">
                <i className="fa fa-eye orange" aria-hidden="true" onClick={() => _doNavToViewStore(record)}></i>
                {AllowWareHouse?.allow_edit==1 && <i className="fa fa-pencil blue" aria-hidden="true" onClick={() => _doNavToEditStore(record)}></i>}
              </div>
            </Space>
          ),
        },
        {
          title: "Cost Center",
          dataIndex: "CostCenter",
          key: "CostCenter"
        },
        {
          title: "Warehouse Name",
          dataIndex: "StoreName",
          key: "StoreName"
        },
        {
          title: "City",
          dataIndex: "City",
          key: "City"
        },
        {
          title: "Zone",
          dataIndex: "Zone",
          key: "ZoneName"
        },
        {
          title: "Status",
          dataIndex: "Status",
          key: "Status"
        },
      ]

    const  States= [];
    const loading= false;
    const  message= '';
    const  modalOpen= false;
  
  const _doNavToEditStore = (record) => {
    dispatch(getSelectedStoreList(record))
    dispatch(isEdit(true))
    // this.props.navigate("/EditWareHouse");
  }
  const _doNavToViewStore = (record) => {
    Cookie.set('storeId', record.storeId)
    dispatch(getSelectedStoreList(record));
    dispatch(showWareHouseView(true));
    
    // this.props.navigate("/WareHouseView");
  }

  const handleSearch = () =>{
    if(searchedItem.wareHouseName.length !=0){
      let data = []
      for(let i =0;i<searchedItem.wareHouseName.length;i++){
        let fetchedData = storeList.filter(ele=> ele.StoreName == searchedItem.wareHouseName[i]).map(element=>data.push(element))
      }
      setTableData(data)
    }else{
      setTableData(storeList);
    }
  }

  const _doSelectVender = (value) => {
    setSearchedItem({
      ...searchedItem,
      wareHouseName: value,
    });
  }

  useEffect(() => {
    dispatch(getWareHouseList(userID, '101'));
  
  }, [])
  useEffect(() => {
    if(searchedItem.wareHouseName.length !=0){
      handleSearch()
    }else{
      setTableData(storeList)
    }
  }, [storeList])


  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const wsData = [
      ['Cost Center', 'Store Name', 'Zone', 'City', 'Status'],
      ...storeList.map(item => [item.CostCenter, item.StoreName, item.Zone, item.City, item.Status])
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, title + '.xlsx');
    XLSX.writeFile(wb, title + '.xlsx');
  };
    
  return (
      <>
        {status?.isWareHouseList ? <div>
          {modalOpen ? (
            <MessageBox
              message={message}
              signout={false}
              // onClose={handleClose}
            />
          ) : null}

          <div className="wrapper">
            <Header title={title} />
            <Menu />
            <div className='content-wrapper'>
              {loading ? (
                <Spinner />
              ) : (
                <div>
                { AllowWareHouse?.add_allow == 1 &&
                  <div className="m-btn-block">
                    <div className="m-btn-block__container">
                      <div className="m-btn-block__icon">
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                      </div>
                      <div className="m-btn-block__btns">
                        <button type='submit' onClick={()=> dispatch(addWareHouse(true))} className='btn btn-secondary deca-btn-yellow'>Create New WareHouse</button>
                      </div>
                    </div>
                  </div>}
                  <section className='content'>
                    {/* <div className="m-page__button">
                          <button type='submit' onClick={this._doNavToAddStore} className='btn btn-secondary deca-btn-yellow'>Create New Store</button>
                        </div> */}
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="row">
                          <div className="col-md-3">
                            <div className='form-group select_h150'>
                              <label htmlFor='exampleInput'>Select Warehouse</label>
                              <Select className="form-control"
                                showSearch
                                mode="multiple"
                                onChange={_doSelectVender}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                value={searchedItem.wareHouseName}
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                storeList?.map((item =>
                                    <Option key={item.storeId} value={item.StoreName}>{item.StoreName}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                          <div className="col-md-3 btn-no-lbl">
                            {/* <button type='submit' className='btn btn-secondary deca-btn-yellow'>
                                        Download Excel
                                      </button> */}
                          <button className='btn btn-secondary deca-btn-yellow' onClick={exportToExcel}>
                            Export to Excel
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="m-table__main">
                          <div className="m-table__responsive medium-width">
                            <Table filterSearch="true" columns={TableColumns} dataSource={tableData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )}
            </div>
            <Footer />
          </div>
        </div> : null}
        {
          status?.isWareHouseEdit ? <EditWareHouse/> : null
        }
        {
          status?.isWareHouseCreate ? <AddWareHouse/> : null
        }
        {
          status?.isWareHouseView ? <WareHouseView/> : null
        }
      </>
    )
}

export default WareHouses;